/**
 * Created by tofael on 9/3/18.
 */
import React, { Component } from 'react';
import Preview from './preview';
import FileChooser from './file-chooser';

class FileUpload extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      selectedFiles: [],
      showPreview: false,
      reportTypes: [
        "Prescriptions",
        "Blood tests",
        "Urine tests",
        "Xray/ Ultrasound/ CTscan",
        "MRI reports",
        "Histopath/ biopsy/ FNAC Report",
        "Others"
      ],
      selectedReportType: '',
    };
  }

  onFilesSelect = (e)=>{
    const selectedFiles = e.target.files;
      this.setState({selectedFiles, showPreview: true});
    };

  closePreview = ()=>{
    this.setState({showPreview: false});
  };

  onSubmit = (selectedFiles, selectedReportType) =>{
    this.setState({showPreview: false});
    this.props.onSubmit(selectedFiles, selectedReportType);
  };
  
  onSelectReportType = (_, __, selectedReportType) =>{
    this.setState({selectedReportType});
  }

  render() {
    const { selectedFiles, showPreview, selectedReportType, reportTypes } = this.state;
    const { label= "Select File", showIcon, style } = this.props;
    return (
      <div style={{display:'inline'}}>
        <FileChooser
          label={label}
          style={style}
          showIcon={showIcon}
          onSelect={this.onFilesSelect}
        />
        <Preview
          onSubmit={this.onSubmit}
          showPreview={showPreview}
          reportTypes={reportTypes}
          selectedFiles={selectedFiles}
          onRequestClose={this.closePreview}
          selectedReportType={selectedReportType}
          onSelectReportType={this.onSelectReportType}
        />
      </div>
    );
  }
}

export default FileUpload;


// WEBPACK FOOTER //
// ./src/screens/shared/file-upload/index.js